import { words } from "../meet-copy";

import { threadOf } from "./thread";
import type { CogentLive } from "./chat-view";

import type { WidgetActions } from "../use-widget-actions";

import s from "../cogent.module.css";

export function ChatComposer({
  name,
  live,
  actions,
}: {
  name: string;
  live: CogentLive | null;
  actions: WidgetActions;
}) {
  const hasThread = live
    ? threadOf(
        live.messages.filter((message) => message.from !== "event").slice(-8),
      ).length > 0
    : false;
  let placeholder = hasThread
    ? `Message ${name}…`
    : words({
        key: "chat.placeholder",
        values: { name },
      });

  if (actions.working) placeholder = "Reply, or /stop to interrupt…";

  return (
    <form className={s.row} onSubmit={actions.ask}>
      <input
        className={s.field}
        aria-label={`Message ${name}`}
        placeholder={placeholder}
        value={actions.question}
        onChange={(event) => actions.setQuestion(event.target.value)}
      />
      <button
        type="submit"
        className={s.send}
        aria-label="Send"
        title="Send"
        disabled={actions.busy || !live?.canSend || !actions.question.trim()}
      >
        <svg viewBox="0 0 16 16" width="16" height="16" aria-hidden="true">
          <path
            d="M8 13V3.5M4 7.5l4-4 4 4"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.6"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </button>
    </form>
  );
}
